export default __webpack_public_path__ + "static/media/ARR Mascots-FAQ1.65d23587.png";